export default __webpack_public_path__ + "static/media/errorNet.6b87ece1.svg";